import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { SubSink } from 'subsink';
import { AppGlobal } from '../../app.global';

@Pipe({
  name: 'myCurrency'
})
export class MyCurrencyPipe implements PipeTransform, OnDestroy {

  private subSunk = new SubSink();
  constructor(
    private appGlobal: AppGlobal,
  ) {
  }

  transform(value: number, from: string) {
    let to: string = 'USD', symbol: string = '$', amnt: number = 0;
    this.subSunk.sink = this.appGlobal.currentCurrency.subscribe(c => {
      symbol = c.split(' ')[0];
      to = c.split(' ')[1];
      this.subSunk.sink = this.appGlobal.todaysRate.subscribe(rates => {
        amnt = (Number(rates[to]) / Number(rates[from])) * Number(value);
      });
    });
    return `${symbol + ' ' + amnt.toFixed(2)}`;
  }

  ngOnDestroy(): void {
    this.subSunk.unsubscribe();
  }

}